import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ConversationAcceptanceResponse, ConversationResponseRequest } from "../models";

@Injectable({ providedIn: "root" })
export class ConversationsService {
    private httpClient = inject(HttpClient);

    public updateResponse(conversationId: string, payload: ConversationResponseRequest): Promise<ConversationAcceptanceResponse> {
        return firstValueFrom(
            this.httpClient.post<ConversationAcceptanceResponse>(`/api/conversations/${conversationId}/respond`, {
                responseAction: "AutoSend",
                ...payload
            })
        );
    }
}
